import { api } from '@/shared';
import type { ApiResponse } from '@/shared/types/api';

export interface DemoRequestData {
  name: string;
  email: string;
  phone: string;
  organizationName: string;
  numberOfFacilities?: number | null;
  numberOfResidents?: number | null;
  preferredDate1?: Date | null;
  preferredDate2?: Date | null;
  preferredDate3?: Date | null;
  timezone?: string | null;
  currentSoftware?: string | null;
  specificNeeds?: string[];
  message?: string | null;
  source?: string | null;
}

export interface DemoRequestResponse {
  success: boolean;
  message: string;
  data?: {
    id: string;
    createdAt: string;
  };
}

/**
 * Submit demo request
 */
export const submitDemoRequest = async (
  data: DemoRequestData,
): Promise<ApiResponse<DemoRequestResponse>> => {
  const response = await api.post<ApiResponse<DemoRequestResponse>>(
    `/demo/request`,
    data,
  );
  return response;
};
